import { Controller } from 'react-hook-form';
import { Search } from '@mui/icons-material';

import SearchTextField from 'Components/SeachTextField/SearchTextField';
import CustomSelect from 'Components/CustomSelect/CustomSelect';
import CustomMultipleSelect from 'Components/CustomMultipleSelect/CustomMultipleSelect';
import CustomDateRangePicker from 'Components/CustomDateRangePicker/CustomDateRangePicker';
import useTranslation from 'Hooks/useTranslation';
import useHistoryCourseEmployeesFilters from 'Hooks/useHistoryCourseEmployeesFilters';
import type { HistoryCourseEmployeesFilterI } from 'types';
import {
  ReportsLayoutFiltersContainer,
  ResetButton,
  SearchButton,
} from '../HistoryReportFilters/HistoryReportFilters.styled';

interface Props {
  onSearch: (filters: HistoryCourseEmployeesFilterI) => void;
}

const STATUS_OPTIONS = [
  { value: '', label: 'Todos' },
  { value: 'pending', label: 'Por Cursar' },
  { value: 'approved', label: 'Aprobado' },
  { value: 'failed', label: 'Reprobado' },
  { value: 'expired', label: 'Vencido' },
];

export const HistoryCourseEmployeesFilter = ({ onSearch }: Props) => {
  const { t2 } = useTranslation('history_course_detail');

  const { control, isDirty, handleReset, getFiltersForApi, terminalsData, departmentsData, jobTitlesData } =
    useHistoryCourseEmployeesFilters({ onSearch });

  return (
    <ReportsLayoutFiltersContainer>
      <Controller
        name="search"
        control={control}
        render={({ field }) => <SearchTextField placeholder={t2('name_or_payroll_placeholder')} {...field} />}
      />

      <Controller
        name="finishedDateRange"
        control={control}
        render={({ field }) => (
          <CustomDateRangePicker label={t2('finished_date')} placeholder="dd/mm/yyyy - dd/mm/yyyy" {...field} />
        )}
      />

      <Controller
        name="terminalId"
        control={control}
        render={({ field }) => (
          <CustomMultipleSelect
            placeholder={t2('terminal')}
            options={terminalsData?.map(terminal => ({
              value: terminal.id,
              label: terminal.name,
            }))}
            {...field}
          />
        )}
      />

      <Controller
        name="departmentId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('department')}
            options={departmentsData?.map(department => ({
              value: department.id,
              label: department.name,
            }))}
            {...field}
          />
        )}
      />

      <Controller
        name="jobTitleId"
        control={control}
        render={({ field }) => (
          <CustomSelect
            placeholder={t2('job_title')}
            options={jobTitlesData?.map(jobTitle => ({
              value: jobTitle.id,
              label: jobTitle.name,
            }))}
            {...field}
          />
        )}
      />

      <Controller
        name="status"
        control={control}
        render={({ field }) => (
          <CustomSelect ariaLabel={t2('status')} placeholder={t2('status')} options={STATUS_OPTIONS} {...field} />
        )}
      />

      <SearchButton
        variant="outlined"
        color="success"
        hidden={!isDirty}
        startIcon={<Search />}
        onClick={() => {
          const values = getFiltersForApi();
          onSearch(values);
        }}
      >
        {t2('search')}
      </SearchButton>

      {isDirty && (
        <ResetButton onClick={handleReset} variant="outlined">
          {t2('clear_filters')}
        </ResetButton>
      )}
    </ReportsLayoutFiltersContainer>
  );
};
